import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, from, map, Observable, of, switchMap } from "rxjs";
import { TokenService } from "src/app/services/CornerStoneServices/token/token.service";
import { environment } from "src/environments/environment";
import {
  ICourseResultShortCStone,
  ICSoneCourseCatalogSearch,
} from "./interfaces/CatalogSearch.interfaces";

@Injectable({
  providedIn: "root",
})
export class CoursesCatalogService {
  endPoint = `${environment.apiUrlCap}/api/cornerStone/request`;
  constructor(
    private http: HttpClient,
    private tokenService: TokenService
  ) {}

  getCoursesCornerList(): Observable<any> {
    this.tokenService.getToken("all").subscribe(r => {});
    return from(this.tokenService.getToken()).pipe(
      switchMap(data => {
        const RBody = {
          path: "Catalog/GlobalSearch",
          token: data.access_token,
          method: "GET",
          body: "",
        };
        const options = {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            accept: "*/*",
          }),
        };
        return this.http.post(this.endPoint, RBody, options);
      }),
      catchError(error => {
        // Error obteniendo el token
        return of(error);
      })
    );
  }

  private htmlToPlainText(html: string): string {
    if (!html) {
      return "";
    }

    const textarea = document.createElement("textarea");

    textarea.innerHTML = html;
    const decoded = textarea.value;

    const div = document.createElement("div");
    div.innerHTML = decoded;

    return div.textContent || div.innerText || "";
  }

  getCoursesCornerByTitleList(
    titleSearch: string
  ): Observable<ICourseResultShortCStone[]> {
    return from(this.tokenService.getToken()).pipe(
      switchMap(data => {
        const RBody = {
          path: `Catalog/GlobalSearch?TrainingType=Event&Title=${titleSearch}`,
          token: data.access_token,
          method: "GET",
          body: "",
        };
        return this.http
          .post<ICSoneCourseCatalogSearch>(this.endPoint, RBody)
          .pipe(
            map(d =>
              d.data.map(({ Title, ObjectId, Description }) => ({
                Title,
                ObjectId,
                Description: this.htmlToPlainText(Description),
              }))
            )
          );
      }),
      catchError(error => {
        return of(error);
      })
    );
  }
}
